const menuAboutNL = {
    "view": {
        "label": {
            "myProfile": "Mijn Profiel",
            "twoFactorAuthentication": "Twee-factor Authenticatie",
            "mySubscription": "Mijn Abonnement",
            "announcements": "Aankondigingen",
            "mySubUsers": "Mijn Subgebruikers",
            "myLabels": "Mijn Labels",
            "escrowWallet": "Escrow Portemonnee",
            "copyright": "Auteursrechtschendingen",
            "financialStatements": "Financiële Overzichten",
            "userStatements": "Gebruikersoverzichten",
            "subuserStatements": "Subgebruiker Overzichten",
            "invoices": "Facturen",
            "paymentMethods": "Betaalmethoden",
            "purchaseHistory": "Aankoopgeschiedenis",
            "accessKeys": "Toegangssleutels",
            "logout": "Uitloggen"
        }
    }
};

export default menuAboutNL;